import React from 'react';
import colors from 'theme/colors';
import { IUser } from 'types/user';
import { Avatar, Group, Stack, Text } from 'ui';

interface IProps {
  id?: string;
  user?: IUser;
  email?: string;
  trailingComponent?: React.ReactNode;
  showUserEmail?: boolean;
  subtitleComponent?: React.ReactNode;
}

const UserCard: React.FC<IProps> = ({
  id,
  user,
  email,
  trailingComponent,
  subtitleComponent = null,
  showUserEmail = false,
}) => {
  const { firstName, lastName, email: userEmail, avatar, id: userId } = user || {};
  const userName = !!firstName || !!lastName;

  return (
    <Group
      className="position-relative"
      style={{ background: colors.dark2 }}
      align="center"
      padding="16px"
      justify="space-between"
      data-cy="user-card"
    >
      <Group gap="12px">
        <Avatar src={avatar} cypressAttribute="user-card-avatar" />
        <Stack gap="0" align="start" justify="center">
          {user && userName ? (
            <Text weight="500" cypressAttribute="user-card-name">
              {firstName} {lastName}
            </Text>
          ) : (
            <Text cypressAttribute="user-card-email" className="break-all pr-4">
              {email}
            </Text>
          )}
          {subtitleComponent}
          {user && showUserEmail && (
            <Text
              color={colors.gray1}
              size="xs"
              cypressAttribute="user-card-email"
              className="break-all pr-4"
            >
              {userEmail}
            </Text>
          )}
        </Stack>
      </Group>
      {trailingComponent}
    </Group>
  );
};

export default UserCard;
